import type { YearGroupInterface } from '@whizz/api-model';
import type Teacher from '@whizz/api-client/dist/@types/model/Teacher';
import { useQuery } from 'react-query';
import { repository } from '@whizz/api-client';
import { QUERIES_IDS } from '../util/vars';
import { useIdentity } from '@whizz/react-identity';
import { useI18n } from '@whizz/react-i18n';

const useYearGroups = (schoolId?: number) => {

  const { me } = useIdentity();
  const { translate } = useI18n();
  const useSchoolId = schoolId ?? (me as Teacher)?.getSchoolId();

  const yearGroupsQuery = useQuery<YearGroupInterface[]>(
    [ QUERIES_IDS.YEAR_GROUPS ],
    () => repository.YearGroupRepository.allBySchoolId(useSchoolId!),
    {
      placeholderData: [],
    },
  );

  const getYearGroupById = (id: number | null | undefined) => {
    if (id && yearGroupsQuery.data) {
      const yearGroup = yearGroupsQuery.data.find((yearGroup) => yearGroup.yearGroupId === id);
      if (yearGroup) {
        return yearGroup;
      }
    }

    return {
      id: null,
      name: translate('global.NO_YEAR_GROUP'),
      code: '',
    };
  };

  return [ yearGroupsQuery, getYearGroupById ] as const;
};

export default useYearGroups;
